// extracted by mini-css-extract-plugin
export default {"schemasidebar":"TimeSheetSidebar_schemasidebar__xQ0bG","schema-sidebar":"TimeSheetSidebar_schema-sidebar__BRxsr","droppableContainer":"TimeSheetSidebar_droppableContainer__nG9Ct"};